import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow p-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-medium leading-6 mb-6" }, "Offering Memorandum", -1)
const _hoisted_3 = {
  class: "flex justify-start",
  "aria-label": "Progress"
}
const _hoisted_4 = {
  role: "list",
  class: "space-y-6"
}
const _hoisted_5 = ["href", "onClick"]
const _hoisted_6 = { class: "flex items-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-shrink-0 h-5 w-5 relative flex items-center justify-center",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-2 w-2 bg-gray-300 rounded-full group-hover:bg-gray-400" })
], -1)
const _hoisted_8 = { class: "ml-3 text-sm font-medium text-gray-500 group-hover:text-gray-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("ol", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (value, key) => {
          return (_openBlock(), _createElementBlock("li", { key: key }, [
            _createElementVNode("a", {
              href: key,
              class: "flex items-start group",
              "aria-current": "step",
              onClick: _withModifiers(($event: any) => (_ctx.goTo(key)), ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("p", _hoisted_8, _toDisplayString(value), 1)
              ])
            ], 8, _hoisted_5)
          ]))
        }), 128))
      ])
    ])
  ]))
}